import howItWorksImg from "../../assets/maskedb.jpg";

export const HowItWorks2 = ({ isEnglish = true }: { isEnglish: boolean }) => {
  return (
    <>
      <main className="web_padding_x web_padding_y ">
        <div className="web_custom_layout_1">
          {/* <img className="custom_layout_img_1" src={howItWorksImg} alt="" /> */}
          {isEnglish && (
            <div className="custom_layout_img_1">
              <iframe
                style={{ width: "100%", height: "100%" }}
                src="https://www.youtube.com/embed/-3ejreju4_8"
                title="How it Works [Sttrand] - ENGLISH"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              ></iframe>
            </div>
          )}
          <div className="">
            <h2 className="web_heading bar_above">How it works</h2>

            <p className="web_paragraph_1 mt-4">
              1. Join a Purchase Group
              <br />
              <br />
              Businesses join a campaign for products they need.
              <br />
              <br />
              2. Combine Demand
              <br />
              <br />
              Sttrand aggregates orders from multiple businesses into a larger purchase.
              <br />
              <br />
              3. Unlock Better Pricing
              <br />
              <br />
              Higher order volumes help secure better wholesale pricing from suppliers.
              <br />
              <br />
              4. Receive Your Products
              <br />
              <br />
              Once the campaign closes, Sttrand coordinates fulfillment and delivery.
              <br />
              <br />
              5. Save More Together
              <br />
              <br />
              Businesses benefit from stronger purchasing power, lower costs, and reliable supply.
              <br />
              <br />
              Understanding Campaign Pricing
              <br />
              <br />
              Production Goal
              The Production Goal is the minimum order quantity required for Sttrand to fulfill
              the campaign and provide the product. If the Production is not reached by the end
              of the campaign, all participants receive a full refund. 
              <br />
              <br />
              End Goal Price
              The End Goal Price is the lowest price Sttrand can offer for a product. As more
              businesses/consumers join a campaign and order volume increases, pricing moves
              closer to the End Goal Price, creating greater savings for all participants.
            </p>
          </div>
        </div>
      </main>
    </>
  );
};
